/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

type AgendaEventFilter = {
  startDate: string;
  endDate: string;
}

export function fetchAgendaEvents (params: AgendaEventFilter): Promise<HalDocument<{
  events: CalendarEvent[]
}>> {
  return rest.get(`/api/agenda/events?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function fetchAgendaEventsCount (params: AgendaEventFilter): Promise<{ count: number }> {
  return rest.get(`/api/agenda/events/count?${stringify(params)}`)
    .then((resp) => resp.json())
}
